import {
  cookieConsentScriptUrl,
  isCookieConsentEnabled,
} from './cookie-consent';

type CookieConsentScriptProps = {
  nonce?: string;
  language?: string;
  preview?: boolean;
};

export function CookieConsentScript({
  nonce,
  language,
  preview = false,
}: CookieConsentScriptProps) {
  if (!isCookieConsentEnabled({ preview: preview })) {
    return;
  }

  return (
    <script
      src={cookieConsentScriptUrl}
      nonce={nonce}
      data-language={language}
      defer
      suppressHydrationWarning
    />
  );
}
